/* eslint-disable */
import request from './helpers'

export function createClient(data) {
  return request({
    url: '/api/v1/clientparam/create',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateClient(id, data) {
  return request({
    url: '/api/v1/clientparam/' + id + '/edit',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function duplicateClient(data) {
  return request({
    url: '/api/v1/clientparam/duplicate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function listClient(clientType) {
  return request({
    url: '/api/v1/clientparam/list',
    method: 'get',
    params: {
        clientType
    }
  })
}

export function getDefault(clientType) {
  return request({
    url: '/api/v1/clientparam/defaultconfig',
    method: 'get',
    params: {
        clientType
    }
  })
}

export function getKeys(clientType) {
  return request({
    url: '/api/v1/clientparam/paramkeys',
    method: 'get',
    params: {
        clientType
    }
  })
}

export function deleteClient(id) {
  return request({
    url: '/api/v1/clientparam/' + id,
    method: 'delete'
  })
}
